<template lang="pug">
#app(:class='{ "masked": masked }')
  .loading.prefetch
  legacy-auth
  md-notifications
  router-view
  //- .close-layer(v-if='!session && store.state.isLoggedIn')
</template>

<script>
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

import {store}                   from '@/components/store'
import {i18n, loadLanguageAsync} from '@/lang/lang'

const $t = (key) => i18n.t(key)

export default {
  name: 'app',

  boot(config) {
    global.app = new config.Vue({
      el         : '#app',
      store      : config.store,
      i18n       : config.i18n,
      router     : config.router,
      template   : '<App/>',
      components : { App: config.App },
      data       : {
        loading  : false,
        masked   : false,
        Chartist : config.Charts.Chartist,
        currentModule : '',
        legacyTab     : '',
        legacySubtab  : '',
        innerHeight   : window.innerHeight
      },
      asyncComputed : {
        getUser     : config.API.getUser
      }
    })

    utils.app = global.app
  },

  created() {
    // i18n
    const lang = navigator.language
    // const lang = 'ro'
    loadLanguageAsync(lang)

    // this.pubnub.load()

    //
    this.$notifications.reset()

    //
    global.alert = function (m) {
      global.app.$notifications.notify({
        alert: true,
        type: 'plain',
        icon: 'exclamation-circle',
        heading: m,
        timeout: 10000,
        allowDismiss: true,
        placement: { from: 'top', align: 'center' }
      })
    }
  },

  mounted() {
    //
    // utils.cssProps.init()
  },

  updated() {
    //
    // utils.cssProps.refresh()
  },

  data() {
    return {
      store
    }
  },

  computed: {
    /**
     * Check session mapped in store and display a notification
     * if logged in and session is invalid
     */
    session() {
      var sessionNotifyIndex

      if (global.app.$notifications && this.$router.currentRoute.params.namespace !== 'docs') {
        setTimeout(() => {
          if (store.state.isLoggedIn && !store.state.isSessionValid) {
            sessionNotifyIndex = global.app.$notifications.state.length + 1
            global.app.$notifications.notify({
              type: 'plain',
              icon: 'exclamation-circle',
              message: $t('Session Expired') +
                        `<br><a class='btn btn-actionbar btn-xs' href="#/login" onclick='window.app.$user.logout()'>` + $t('login.button') + `</a>`,
              timeout: 0,
              allowDismiss: false,
              placement: { from: 'top', align: 'center' }
            })
          } else {
            global.app.$notifications.removeNotification(sessionNotifyIndex)
          }
        })
      }

      return store.state.isSessionValid
    }
  }
}

</script>

<style lang='scss'>
@import '~@/assets/sass/font-awesome/fontawesome-pro-brands.scss';
@import '~@/assets/sass/font-awesome/fontawesome-pro-core.scss';
@import '~@/assets/sass/font-awesome/fontawesome-pro-light.scss';
@import '~@/assets/sass/font-awesome/fontawesome-pro-regular.scss';
@import '~@/assets/sass/font-awesome/fontawesome-pro-solid.scss';

@import "~@/assets/sass/_variables.scss";
@mixin loader-bar() {
  &:after {
    top: 0;
    margin: 0;
    height: 2px;
    width: 100%;
    position: fixed;
    overflow: hidden;
    background-color: #fff;
  }
  &:before {
    left: 0;
    top: 0;
    margin: 0;
    display: block;
    position: fixed;
    content: "";
    left: -200px;
    width: 200px;
    height: 2px;
    @include theme {
    background-color: v(tertiary-01);
    }
    animation: loading-bar 2s linear infinite;
    z-index: 9999999;
  }
  @keyframes loading-bar {
      from { left:     0%; width:   0; }
      50%  { left:    10%; width: 20%; }
      70%  { left:    30%; width: 70%; }
      80%  { left:    50%; width: 50%; }
      95%  { left:    90%; width: 10%; }
      to   { left:   100%; width:   0; }
  }
}

a:not(.btn) {
  @include theme { color: $primary-alt }
  &:hover {
    color: $ink;
  }
}

html body #app[class] {
  &.masked {
    .theme.skin  .main-panel:after {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: .7;
      z-index: 100001;
      background-color: #000;
    }
  }
}

#layout {
  height: 100%;

  .wrapper {
    .main-panel {
      overflow-y: scroll;

      body[legacy-modal="true"] & {
        overflow-y: hidden;
      }
    }
    &.nav-open .main-panel {
      //overflow-y: hidden;
    }
  }

  &.layout-auth .main-panel {
    overflow-y: auto;
  }

  .grid.component {
    padding-top: 0;
  }
}

#layout {
  .card:not(.r-show) {
    display: inherit;
  }
  &.scoped .card:not(.r-show) {
    display: none;
  }
  &.scoped [class^="col-"] {
    min-height: 0;
  }
}

.close-layer {
  background: #000;
  height: 100%;
  width: 100%;
  position: absolute;
  opacity: 0.8;
  top: 0;
  left: auto;
  content: "";
  z-index: 99999;
  overflow-x: hidden;
  &.visible{
      opacity: 1;
  }
  .theme.docs + & {
    display: none;
  }
}

.notifications {
  position: relative;
  z-index: 10000;
}

.loading.loading.main-panel {
  &:before {
    position: fixed;
  }
  .content.module {
    position: relative;
    &:after {
      display: none;
      top: -300px;
      height: calc(100% + 300px);
    }
  }
  &:after {
    display: none;
  }
}
.loading:not(.fa-bell) {
  position: relative;

  &.main-panel {
    @include loader-bar;
  }

  &:before {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -25px;
    margin-left: -25px;
    font: 50px 'Font Awesome 5 Regular';
    content: '\f1ce';
    z-index: 10000;
    animation: fa-spin 2s infinite linear;
    @include theme() {
    color: v(primary-04);
    }
  }
  &.widget-select:before {
    @include theme() {
    color: v(canvas);
    }
  }
  .content.module:after,
  &:after {
    content: '';
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    //background: #eee url('../static/images/loading.svg') 50% 50% no-repeat;
    //background-size: 50px;
    background: #eee;
    opacity: .55;
    z-index: 1000000;
  }
  &[endpoint]:after {
    z-index: 9;
    background-image: none;
  }
  &.btn {
    color: transparent;
    cursor: not-allowed;
    box-shadow: none;
    &:hover,
    &:active,
    &:focus
    {
      color: transparent;
      box-shadow: none;
    }
    &:after {
      //
    }
    &:before {
      font-size: 22px;
      margin-top: -11px;
      margin-left: -11px;
    }
    &.alt:before {
      color: $primary-alt;
    }
  }
}

// DRAG-DROP
.vue-grid-item {
  &.vue-grid-placeholder {
    @include theme() {
    background: v(secondary-02);
    }

    &[data-valid="false"] {
      @include theme() {
        background: v(urgent-01);
      }
    }
  }

  &.widget.vue-resizable {
    min-width: 32%;
  }

  > .vue-resizable-handle {
    @include fa-icon($fa-var-expand-alt);
    @include fa-icon-flip(-1, 1, 0);
    right: 2px;
    bottom: -2px;
    @include theme() {
    color: v(ink);
    }
  }

  &.top, &.picker-top {
    z-index: 1;
  }
}


.loading.prefetch {
  &:before {
    z-index: -1;
  }
  margin-left: -99999px;
  position: absolute;
}

// TOOLTIPS
.tooltip {
  display: block !important;
  z-index: 10000;

  &.hide {
    display: none !important;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .tooltip-inner {
    margin-top: 10px;
    background: #696969;
    @include theme {
    background: v(border);
    }
    color: white;
    border-radius: 5px;
    padding: 1px 5px 0px;
    box-shadow: none;
    font-family: $font-family;
    font-size: 0.96em;
    letter-spacing: 0.03em;
    font-weight: $font-weight-light;
    min-width: 0;
    max-width: 400px;
    // transform: rotate(0.03deg);
    color: #fff;
  }

  .tooltip-arrow {
    display: none;
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #696969;
    @include theme {
    border-color: v(border);
    }
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &.option-tooltip {
    margin-top: -20px;
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
  #app:has(.mobile) .notifications .md-notification {
    &.alert-info {
      margin-top: 12px;
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue